import { getApp } from 'firebase/app';
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
} from 'firebase/app-check';

import { prod, reCaptchaKey } from '../env-constants';

export const initAppCheck = () => {
  if (!prod) {
    (window.self as any).FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }

  return initializeAppCheck(getApp(), {
    provider: new ReCaptchaEnterpriseProvider(reCaptchaKey),
    isTokenAutoRefreshEnabled: true,
  });
};
